import {environment} from '../../environments/environment';
import {appVersion} from '../../environments/version';

// ira-groupnet.app と同形: 向き先は environments/environment.{ts,stage.ts,prod.ts} で切替。
// - domain: SPA を配信する host。apiDomain: backend/OrientDB のエンドポイント host。
//   apiDomain 未指定 (空) なら従来どおり domain と同じ (同一 origin、CORS 不要)。
//   移行期間中は SPA を旧サーバ (旧 DNS) から配信しつつ API だけ新 backend
//   (dev.active-promotion.jp / active-promotion.jp) に向けるため別指定する。
//   cross-origin になるので backend の CORS_ALLOWED_ORIGINS と deployment 側
//   orientdb router の CORS 設定が前提。
// - dev (environment.ts): remote=false、window.location 由来 (traefik port 80 経由、
//   ng serve 直叩きは proxy.conf.json)
export class KaitoriyaConfig {
    public static location = window.location;
    public static remote = environment.remote;
    public static production = true;   // gapi key / spreadsheet 切替 (従来どおり固定)
    public static DOMAIN = environment.domain;
    public static API_DOMAIN = environment.apiDomain || environment.domain;
    public static PORT = KaitoriyaConfig.remote ? '443' : '80';
    public static DATABASE = environment.database || 'kaitoriya';
    public static SERVER_URL = KaitoriyaConfig.remote ? 'https://' + KaitoriyaConfig.API_DOMAIN + ':' + KaitoriyaConfig.PORT + '/server' : window.location.protocol + '//' + KaitoriyaConfig.API_DOMAIN + '/server';
    public static DATABASE_URL = KaitoriyaConfig.remote ? 'https://' + KaitoriyaConfig.API_DOMAIN + ':' + KaitoriyaConfig.PORT + '/api' : window.location.protocol + '//' + KaitoriyaConfig.API_DOMAIN + '/api';
    public static PREFIX = '';
    public static VERSION = appVersion;
}
